<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-table-columns"></i></div>
      <div>
        Interfaces
        <div class="page-title-subheading">Configurations des interfaces de: {{role?.name}}</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    

    <div class="card">
        <div class="card-body">
            <ul>
                <li *ngFor="let w of windowsMenu; let i=index">
                                
                            <h4 class="d-flex justify-content-between" > 
                                <label style="cursor: pointer;"  for="cw{{i}}">
                                <span class="{{w.status?'text-dark fw-bold':'text-muted'}}"><i class="fa fa-chevron-right"></i> {{w.title}} (T)</span>
                                </label>
                                <div class="form-check">
                                    <input id="cw{{i}}" class="form-check-input" type="checkbox" name="status" [(ngModel)]="w.status">
                                  </div>
                            </h4>
                            <hr>
                            <div *ngFor="let el of w.elements; let e=index" >
                                <h5 class="ms-2 d-flex justify-content-between "> 
                                    <label style="cursor: pointer;"  for="cw{{e}}">
    
                                    <span class="{{el.status?'text-dark fw-bold':'text-muted'}}"><i class="fa fa-chevron-right"></i> {{el.name}} (T)</span>
                                    </label>
                                    <div class="form-check">
                                        <input id="cw{{e}}" class="form-check-input" type="checkbox" name="status" [(ngModel)]="el.status">
                                      </div>
                                </h5>
                                <hr>
                                <ul class="ms-3" *ngIf="el.hasChildren">
                                    <li   *ngFor="let c of  el.children; let j=index">
                                        <h6 class="ms-1 d-flex justify-content-between"> 
                                            <label style="cursor: pointer;"  for="cw{{i}}{{e}}{{j}}">
                                                <span class="{{c.status?'text-dark fw-bold':'text-muted'}}"><i class="fa fa-chevron-right"></i> {{c.name}} (M)</span>
                                            </label>
                                            <div class="form-check">
                                                <input id="cw{{i}}{{e}}{{j}}" class="form-check-input" type="checkbox" name="status" [(ngModel)]="c.status">
                                              </div>
                                        </h6>
                                    </li>
                                    <hr>
                                </ul>
                            </div>
                       
                </li>
            </ul>
        </div>

        <div class="card-footer text-end">
            <button *ngIf="windowsMenu.length!=0" (click)="store()" class="btn btn-outline-dark" [disabled]="loading" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
          </div>
    </div>
 